
















import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { ITextJoinBehavior, IJoinedTextItem } from "../../../../domain/format/objects";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";
import { IFormatObjectEditable } from "../../../../../formatEditor/domain/editableFormat";

@Component
export default class TextJoinBehaviorEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ITextJoinBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITextJoinBehavior) => T, defaultValue: T) => T;

  @Prop()
  commonComponents: CommonComponentsContainer;

  get shouldJoinWithNewLine(): boolean {
    return this.readPropertyOrDefault(s => s.shouldJoinWithNewLine, false);
  }

  set shouldJoinWithNewLine(value: boolean) {
    this.writePropertyWhenValid(s => s.shouldJoinWithNewLine = value);
  }

  get items(): IJoinedTextItem[] {
    return this.readPropertyOrDefault(s => s.items, []);
  }

  set items(value: IJoinedTextItem[]) {
    this.writePropertyWhenValid(s => s.items = value);
  }

  get selectionObjects(): IFormatObjectEditable[] {
    return Enumerable.from(this.commonComponents.allPagesFormatObjects)
      .where(o => this.conditionsOfLinkedObject(o) &&
        (o.objectTypeName().getValue() === "text" || o.objectTypeName().getValue() === "tag" || o.objectTypeName().getValue() === "combo"))
      .toArray();
  }

  private conditionsOfLinkedObject(object: IFormatObjectEditable): boolean {
    const linkedObject = object.toLinkedObjectIdentifier();
    return !!linkedObject.id && !!linkedObject.key && linkedObject.key !== "";
  }

  async showTextJoinItemEditDialog() {
    const dialog = this.commonComponents.getDialogs().getTextJoinItemEditDialog();
    const textJoinItems = await dialog.show(this.items, this.selectionObjects);
    if (!textJoinItems) { return; }
    this.items = textJoinItems;
  }
}
